import React, { Component } from 'react'
import { Link } from 'react-router-dom'
// import Filter from './Filter'

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      filter: null
    }
    this.applyFilter = this.applyFilter.bind(this)
  }

  applyFilter (filter) {
    this.setState({ filter })
  }

  render () {
    return (
      <div>
        <div className='row'>
          <div className='col'>
            <h1>CEC Data Repository</h1>
            <p className='lead'>Explore data on Canadian clean energy initiatives, and find the appropriate member of the federal House of Commons or provincial legislative assembly.</p>
          </div>
        </div>
        <div className='row margin-top-2x'>
          <div className='col'>
            <h2>Available data</h2>
          </div>
        </div>
        <div className='row'>
          <div className='col'>
            <Link to='/federal-ridings'>
              <h3>Federal ridings</h3>
              <p className='lead'>A list of all federal ridings in Canada, along with their representatives. &rarr;</p>
            </Link>
          </div>
          <div className='col'>
            <Link to='/provincial-ridings'>
              <h3>Provincial ridings</h3>
              <p className='lead'>A list of provincial ridings in BC, Alberta, Saskatchewan, Ontario, and Québec, along with their representatives. &rarr;</p>
            </Link>
          </div>
          <div className='col'>
            <Link to='/power-projects'>
              <h3>Power projects</h3>
              <p className='lead'>A list of clean energy power projects across Canada, including location and total MW. &rarr;</p>
            </Link>
          </div>
          <div className='col'>
            <Link to='/other-projects'>
              <h3>Other projects</h3>
              <p className='lead'>A list of other clean tech projects, including incubators and test facilities. &rarr;</p>
            </Link>
          </div>
        </div>
        <div className='row margin-top-2x'>
          <div className='col'>
            <h2>Support</h2>
            <p>If you encounter any problems with the tool or data, please contact <a href='mailto:frank@plotandscatter.com?subject=CEC Data Repository'>Frank Hangler</a>.</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/App/Home.js